import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import apis from './apis';

// Axios instance
const axiosInstance = axios.create();

const TestEnv = process.env.REACT_APP_TEST_ENV || false;

/**
 * Mock configs
 */
const MockConfigs = {
  delayResponse: 1500
};

const WithMock = (intance, method) => async (...args) => {
  try {
    const validArgs = args.filter((arg) => arg !== null);
    if (validArgs.length < intance.length) {
      throw new TypeError('Argument cannot be null or undefined.');
    }
    if (TestEnv === 'true') {
      applyMockApis(new MockAdapter(intance, MockConfigs));
    }
    const { data, status } = await intance[method](...validArgs);
    return { data, status, error: null };
  } catch (E) {
    return { data: null, error: E };
  }
};

const applyMockApis = (mock) => {
  mock
    .onPost(apis.setupFromPluginIdApi());
  // .reply(200, getInfoMock);

  mock
    .onAny()
    .passThrough();

  return mock;
};

// JSDOC
/**
 * Helper method to get data from anywhere
 *
 * @param {string} method GET|POST|...
 * @param {string} endpoint url to fetch data
 * @param {object} payload request payload object. defaults to empty object
 * @param {object} options override request options (e.g headers)
 *
 * @returns {object} including data and status
 * @author Alireza zbr
 */
// DRY vs WET
const cts = async (method, endpoint, payload = {}, options = {}) => {
  try {
    const { data, status } = await WithMock(axiosInstance, method)(endpoint, payload, options);
    return Promise.resolve({ data, status });
  } catch (e) {
    return Promise.reject();
  }
};

export default cts;
